'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var createPrepareActionForServerFn = exports.createPrepareActionForServerFn = function createPrepareActionForServerFn(store) {
    return function (action) {
        var user = store.getState().getIn(['app', 'currentUser']);

        return _extends({}, action, {
            user: {
                _id: user.get('_id'),
                clientId: user.get('clientId'),
                clientTick: user.get('clientTick')
            },
            undoRedoAction: undefined,
            transactionId: undefined,
            isUndo: undefined,
            isRedo: undefined
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/socket/middleware/createPrepareActionForServerFn.js
// module id = 2140
// module chunks = 0